import {
  DASHBOARD_JOB_FETCH_BEGIN,
  DASHBOARD_JOB_FETCH_FAIL,
  DASHBOARD_JOB_FETCH_SUCCESS,
} from 'actions/dashboardActions';
import get from 'lodash/get';
import DashboardState from './state';
import { DashboardTypes } from './types';

const INITIAL_STATE = new DashboardState();

export default function dashboardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    //-------------------------------------------------
    // GET_DASHBOARD
    case DashboardTypes.GET_DASHBOARD.LOADING:
      return {
        ...state,
        dashboard: {
          ...INITIAL_STATE.dashboard,
          loading: true,
        },
      };
    case DashboardTypes.GET_DASHBOARD.SUCCESS:
      return {
        ...state,
        dashboard: {
          ...INITIAL_STATE.dashboard,
          data: action.payload,
        },
      };
    case DashboardTypes.GET_DASHBOARD.ERROR:
      return {
        ...state,
        dashboard: {
          ...INITIAL_STATE.dashboard,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_DASHBOARD_SUPPLIER_DOCUMENT
    case DashboardTypes.GET_DASHBOARD_SUPPLIER_DOCUMENT.LOADING:
      return {
        ...state,
        supplierDocument: {
          ...INITIAL_STATE.supplierDocument,
          loading: true,
        },
      };
    case DashboardTypes.GET_DASHBOARD_SUPPLIER_DOCUMENT.SUCCESS:
      return {
        ...state,
        supplierDocument: {
          ...INITIAL_STATE.supplierDocument,
          data: get(action.payload, 'list', []),
          total: get(action.payload, 'total', 0),
        },
      };
    case DashboardTypes.GET_DASHBOARD_SUPPLIER_DOCUMENT.ERROR:
      return {
        ...state,
        supplierDocument: {
          ...INITIAL_STATE.supplierDocument,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_DASHBOARD_AUDIT_CERTIFICATION
    case DashboardTypes.GET_DASHBOARD_AUDIT_CERTIFICATION.LOADING:
      return {
        ...state,
        auditCertification: {
          ...INITIAL_STATE.auditCertification,
          loading: true,
        },
      };
    case DashboardTypes.GET_DASHBOARD_AUDIT_CERTIFICATION.SUCCESS:
      return {
        ...state,
        auditCertification: {
          ...INITIAL_STATE.auditCertification,
          data: get(action.payload, 'list', []),
          total: get(action.payload, 'total', 0),
        },
      };
    case DashboardTypes.GET_DASHBOARD_AUDIT_CERTIFICATION.ERROR:
      return {
        ...state,
        auditCertification: {
          ...INITIAL_STATE.auditCertification,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_DASHBOARD_PRODUCT_CERTIFICATION
    case DashboardTypes.GET_DASHBOARD_PRODUCT_CERTIFICATION.LOADING:
      return {
        ...state,
        productCertification: {
          ...INITIAL_STATE.productCertification,
          loading: true,
        },
      };
    case DashboardTypes.GET_DASHBOARD_PRODUCT_CERTIFICATION.SUCCESS:
      return {
        ...state,
        productCertification: {
          ...INITIAL_STATE.productCertification,
          data: get(action.payload, 'list', []),
          total: get(action.payload, 'total', 0),
        },
      };
    case DashboardTypes.GET_DASHBOARD_PRODUCT_CERTIFICATION.ERROR:
      return {
        ...state,
        productCertification: {
          ...INITIAL_STATE.productCertification,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_DASHBOARD_PRODUCT_TESTING
    case DashboardTypes.GET_DASHBOARD_PRODUCT_TESTING.LOADING: {
      return {
        ...state,
        productTesting: {
          ...INITIAL_STATE.productTesting,
          loading: true,
        },
      };
    }
    case DashboardTypes.GET_DASHBOARD_PRODUCT_TESTING.SUCCESS: {
      return {
        ...state,
        productTesting: {
          ...INITIAL_STATE.productTesting,
          data: get(action.payload, 'list', []),
          total: get(action.payload, 'total', 0),
        },
      };
    }
    case DashboardTypes.GET_DASHBOARD_PRODUCT_TESTING.ERROR: {
      return {
        ...state,
        productTesting: {
          ...INITIAL_STATE.productTesting,
          error: action.payload,
        },
      };
    }

    case DASHBOARD_JOB_FETCH_BEGIN:
      return { chartData: {}, status: 'fetching' };

    case DASHBOARD_JOB_FETCH_SUCCESS:
      return {
        chartData: {
          ...action.data,
        },
        status: 'viewing',
      };

    case DASHBOARD_JOB_FETCH_FAIL:
      return { chartData: {}, status: 'failed', failReason: action.reason };

    //-------------------------------------------------
    // GET_EXPIRING_REPORTS
    case DashboardTypes.GET_EXPIRING_REPORTS.LOADING:
      return {
        ...state,
        expiringReports: {
          ...INITIAL_STATE.expiringReports,
          loading: true,
        },
      };
    case DashboardTypes.GET_EXPIRING_REPORTS.SUCCESS:
      return {
        ...state,
        expiringReports: {
          ...INITIAL_STATE.expiringReports,
          data: get(action.payload, 'list', []),
          total: get(action.payload, 'total', 0),
        },
      };
    case DashboardTypes.GET_EXPIRING_REPORTS.ERROR:
      return {
        ...state,
        expiringReports: {
          ...INITIAL_STATE.expiringReports,
          error: action.payload,
        },
      };

    default:
      return state;
  }
}
